



















import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseIcon from '../base-icon/_base-icon.vue';
import { TableAlign } from './enums/table-align';
import { SortOrder } from './enums/sort-order';

@Component({
  name: 'BaseTableHeaderCellSortable',
  components: { BaseIcon },
  data: () => ({
    SortOrder,
  }),
})
export default class BaseTableHeaderCellSortable extends Vue {
  @Prop({ default: TableAlign.Left }) align: TableAlign;
  @Prop({ default: false }) active: boolean;
  @Prop() direction: SortOrder;
  @Prop() dataExternal?: string;
}
